import {Notification} from '@baidu/acud-element-ui';
import Axios from 'axios';
import Cookies from 'js-cookie';
import Config from '@/config';
import i18n from '@/i18n';
import trackBehavior, {getMonitorCurrentPageView} from '@/utils/trackLog';

let baseURL = '/api';
const greyVersion = sessionStorage.getItem('_ticket_version_');

const $axios = Axios.create({baseURL});

export const getCsrftoken = () => Cookies.get('bce-user-info') as string;

export const notificationMsg = (requestId: string, message: string, status?: number) => {
    Notification({
        type: 'warning',
        title: `${i18n.t('fu-wu-qi-cuo-wu')}${status ? `(${status})` : ''}`,
        dangerouslyUseHTMLString: true,
        message: `
            ${i18n.t('cuo-wu-xin-xi')}: ${message}
            <br/>
            ${i18n.t('cuo-wu-ma')}: ${requestId || ''}
            <i
                class="el-icon-copy-document"
                onclick="window.navigator.clipboard.writeText('${requestId}');"
            ></i>
        `,
        duration: 5000,
        customClass: 'http-notify',
    });
};

// 拦截请求
$axios.interceptors.request.use(
    config => {
        // 1. 添加百度云前端请求头安全校验
        config.headers!.csrftoken = getCsrftoken();

        // 2. 国际化
        // console国际化需要在query里添加 locale 参数
        // console 只支持 zh-cn 和 en-us 两种语言类型
        // http://bce.console.baidu-int.com/bce-doc/doc/view/93286b91-4960-4b99-b4d8-914e3981e991 尾部
        const separator = config.url?.includes('?') ? '&' : '?';
        config.url += `${separator}locale=${i18n.locale}`;

        // 3. 开发环境切换、灰度
        if (greyVersion) {
            config.headers = {
                ...config.headers,
                'X-Bce-Access-Version': 'TICKET_PLAT:white|TICKET_WEBSOCKET:white',
            };
        }

        // 4. 虚商环境时，添加指定头部
        if (Config.IS_XS) {
            config.headers = {
                ...config.headers,
                'x-bce-source': 'CONSOLE_XS',
            };
        }

        // OPT: 搞清楚作用，有的时候不需要
        if (!config.url?.includes('survey/need_login/apply')) {
            config.headers = {
                ...config.headers,
                'X-silence': true,
                // 'X-Bce-Access-Version': xBceAccessVersion,
            };
        }

        // 公共请求头
        const {pageViewId, siteSessionId} = getMonitorCurrentPageView();
        config.headers = {
            ...config.headers,
            'x-bce-pvid': pageViewId,
            'x-bce-ssid': siteSessionId,
        };

        return config;
    },
    err => {
        trackBehavior({
            category: 'http接口',
            name: '请求报错',
            action: 'request',
            value: err,
        });
        return Promise.reject(err);
    }
);

// 拦截响应
$axios.interceptors.response.use(
    response => {
        // 提供跳过通用异常处理功能
        if (response.config.headers?.commonErrorCatch as any === false) {
            return response;
        }
        // 无权限状态无需提示
        // 已通过 store/user.ts 中判断权限，无权限时页面会渲染为无权限页面
        if (response.data.code === 'BceSignatureValidateException.UnauthorizedException') {
            return response;
        }

        // OPT: console 部分接口异常返回 response.data.success 为 'false'
        // 会影响到实例接入部分，暂时不修改
        // if ((response.data.success === false || response.data.success === 'false') && response.data.message) {
        if (response.data.success === false && response.data.message) {
            trackBehavior({
                category: 'http接口',
                name: '响应报错',
                action: 'response',
                value: response.data,
            });
            const redirect = response.data.message.redirect;
            if (redirect) {
                if (window.isSupportIframe) {
                    window.parent.location.href = redirect;
                }
                else {
                    location.href = redirect;
                }
                return response;
            }
            if (response.config.headers!['X-Disable-Error-Msg']) {
                // 这种情况下不提示错误信息
                return response;
            }

            // 错误信息提示
            const {requestId, error, message, status} = response.data;
            notificationMsg(
                requestId,
                error?.message || message.global,
                status
            );
            // 业务逻辑都没有 catch，这里reject，会导致发生异常时很多 loading 不能正确关闭
            // return Promise.reject({err: response});
        }
        return response;
    },
    err => {
        trackBehavior({
            category: 'http接口',
            name: '响应报错',
            action: 'response',
            value: err,
        });

        const config = {// 全局配置网络问题响应
            type: 'error',
            message: i18n.t('wang-luo-cuo-wu-ti-shi'),
            duration: 4000,
            customClass: 'http-notify',
        };
        Notification(config as any);

        return Promise.reject(err);
    }
);

export default $axios;
